import xhr from './xhr';

export default function(options) {
  return new Promise((resolve, reject) => {
    xhr({
      ...options,
      onSuccess: (data, request) => resolve({ data, request }),
      onFailure: reject,
      onTimeout: reject
    });
  });
}
